




























































































































import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';

import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';

import { Vue, Component, Prop } from 'vue-property-decorator';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '@/components/Confirmation.vue';

import { fetchMantenedorCoordinador } from '@/pantallas/Conecta/MantenedorCoordinador/fetchMantenedorCoordinador';
import { getDate } from './helpers/getDate';
import { getUserId } from './helpers/getUserId';
import { messagesError } from './helpers/messagesError';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    CrudStepsNavBar,
    FormFieldsContainer,
    'app-confirmacion': Confirmation,
  },
})
export default class ModalViewCoordinador extends Vue {
  @Prop({ default: true, type: Boolean }) show: boolean;
  @Prop({ default: {}, type: Object }) data: any;
  @Prop({ default: true, type: Boolean }) anulado: any;
  @Prop({ default: {} }) tipo: any;
  readonly funcionalidad: Funcionalidades = Funcionalidades.coordinador;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  invalidName: boolean = false;
  invalidLastName: boolean = false;
  messageName: string = '';
  dialogPopUp: boolean = false;
  messageLastName: string = '';

  opciones: any[] = ['ACTIVO', 'INACTIVO'];

  formFields: FormFieldDefMap = {
    coorname: {
      label: 'Nombre del coordinador',
      id: '',
      value: Object.keys(this.data).length === 0 ? '' : this.data.coorname,
    },
    coorapellido: {
      label: 'Apellido del coordinador',
      id: '',
      value: Object.keys(this.data).length === 0 ? '' : this.data.coorapellido,
    },
    coorfecha_alta: {
      label: 'Fecha De Registro',
      id: '',
      value:
        Object.keys(this.data).length === 0
          ? getDate()
          : this.data.coorfecha_alta.substring(0, 19),
    },
    coorbaja: {
      label: 'Estado',
      id: '',
      value: this.data.coorbaja,
    },
    coortipo: {
      label: 'Tipo',
      id: this.data.coortipo,
      value: this.data.coortipo,
    },
  };

  validateName() {
    const pattern: RegExp = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]*$/;
    const validate: string = (this.formFields.coorname.value as string)
      .trim()
      .replace(/\s+/g, ' ');
    if (!pattern.test(this.formFields.coorname.value as any)) {
      this.invalidName = true;
      this.messageName = messagesError.validateCoorName;
    } else if (!validate) {
      this.invalidName = true;
      this.messageName = messagesError.blanckCoorName;
    } else {
      this.invalidName = false;
      this.messageName = '';
    }
  }

  validateLastName() {
    const pattern: RegExp = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]*$/;
    const validate: string = (this.formFields.coorapellido.value as string)
      .trim()
      .replace(/\s+/g, ' ');
    if (!pattern.test(this.formFields.coorapellido.value as any)) {
      this.invalidLastName = true;
      this.messageLastName = messagesError.validateCoorApellido;
    } else if (!validate) {
      this.invalidLastName = true;
      this.messageLastName = messagesError.blanckCoorApellido;
    } else {
      this.invalidLastName = false;
      this.messageLastName = '';
    }
  }

  pasoActivoIndex = 1;
  readonly pasos: PasosCrud = {
    requerimiento: {
      accion: 'Editar Coordinador',
      visible: true,
      step: 1,
      title: 'Asignación de detalle',
      icon: 'ballot',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
    },
  };

  selectedTipo() {
    return this.tipo.find(
      (item: { configvalor: any }) =>
        item.configvalor.toString() ===
        this.formFields.coortipo.value.toString()
    );
  }

  handleAdd() {
    if (
      !this.formFields.coorname.value &&
      !this.formFields.coorapellido.value
    ) {
      this.invalidName = true;
      this.messageName = messagesError.blanckCoorName;
      this.invalidLastName = true;
      this.messageLastName = messagesError.blanckCoorApellido;
    } else if (!this.formFields.coorname.value) {
      this.invalidName = true;
      this.messageName = messagesError.blanckCoorName;
    } else if (!this.formFields.coorapellido.value) {
      this.invalidLastName = true;
      this.messageLastName = messagesError.blanckCoorApellido;
    }
    if (this.formFields.coortipo.value) {
      this.addCoordinadores();
    } else {
      this.$snotify.error('El campo de tipo no puede estar vacio', {
        timeout: 3000,
      });
    }
  }

  handlePopUp(event: any) {
    if (this.anulado) {
      this.handleClosed();
    } else {
      this.dialogPopUp = !this.dialogPopUp;
      if (event) {
        this.handleClosed();
      }
    }
  }

  handleClosed() {
    this.$emit('cerrar');
  }

  showPopuP(event: any) {
    this.dialogPopUp = !this.dialogPopUp;
    if (event) {
      this.handleClosed();
    }
  }

  async addCoordinadores() {
    let self = this;
    const requestData: any = {
      coorname: this.formFields.coorname.value.toString().toUpperCase(),
      coorapellido: this.formFields.coorapellido.value.toString().toUpperCase(),
      coortipo: this.formFields.coortipo.value.toString(),
    };

    if (Object.keys(this.data).length !== 0) {
      requestData.coorid = Number(this.data.coorid);
      requestData.usuarioid_modifica = getUserId();
      requestData.usuariorut_modifica = localStorage.getItem('clienteDefecto');
      requestData.coorbaja =
        this.formFields.coorbaja.value == 'ACTIVO' ? 'f' : 't';
      requestData.previus_data = this.data;
    } else {
      requestData.usuarioid_alta = getUserId();
      requestData.usuariorut_alta = localStorage.getItem('clienteDefecto');
    }

    return fetchMantenedorCoordinador(
      requestData,
      'api_coordinadores/add_coordinador'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '2') {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return;
        }
        if (data.data.MENSAJE_RESPUESTA !== '') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.handleClosed();
        } else {
          this.handleClosed();
        }
      })
      .catch((error: any) => {})
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
}
